"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AngleUp_exports = {};
__export(AngleUp_exports, {
  default: () => AngleUp_default
});
module.exports = __toCommonJS(AngleUp_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M22.2892 17.7057L12.7723 8.38753C12.6794 8.29425 12.569 8.22024 12.4474 8.16973C12.3258 8.11923 12.1954 8.09324 12.0638 8.09324C11.9321 8.09324 11.8018 8.11923 11.6802 8.16973C11.5586 8.22024 11.4482 8.29425 11.3553 8.38753L1.71129 17.6292C1.61838 17.7225 1.50797 17.7965 1.38638 17.847C1.2648 17.8975 1.13444 17.9235 1.00279 17.9235C0.871135 17.9235 0.740777 17.8975 0.619195 17.847C0.497612 17.7965 0.387199 17.7225 0.294289 17.6292C0.201012 17.5363 0.127 17.4259 0.0764983 17.3043C0.0259967 17.1827 0 17.0524 0 16.9207C0 16.7891 0.0259967 16.6587 0.0764983 16.5371C0.127 16.4155 0.201012 16.3051 0.294289 16.2122L9.9403 6.97453C10.5042 6.41162 11.2685 6.09548 12.0653 6.09548C12.8621 6.09548 13.6263 6.41162 14.1903 6.97453L23.7062 16.2897C23.7993 16.3826 23.8732 16.493 23.9236 16.6144C23.974 16.7359 24 16.8662 24 16.9977C24 17.1292 23.974 17.2595 23.9236 17.381C23.8732 17.5025 23.7993 17.6128 23.7062 17.7057C23.6133 17.799 23.5029 17.873 23.3813 17.9235C23.2597 17.974 23.1294 18 22.9977 18C22.8661 18 22.7357 17.974 22.6141 17.9235C22.4925 17.873 22.3821 17.799 22.2892 17.7057Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgAngleUp = SvgIcon;
var AngleUp_default = SvgAngleUp;
//# sourceMappingURL=AngleUp.js.map